import Instance from '../../../Axios';

const EnviarPeqAlmocos = (ydata) => async (dispatch) => {
  console.log(ydata);
  await Instance()
    .post('/backend/peqalmocos', { ydata })
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'POST_PEQ_ALMOCOS', payload: data });
      //   show('success', 'Foram associados novos funcionários á obra');
    })
    .catch((err) => {
      // eslint-disable-next-line eqeqeq
      if (err.response.status != 200) {
        // show('warning', 'Preencha todos os campos');
      }
    });
};

export default EnviarPeqAlmocos;
